import { render, staticRenderFns } from "./listaMenu.vue?vue&type=template&id=aa0afc34"
import script from "./listaMenu.vue?vue&type=script&lang=js"
export * from "./listaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports